import { useDispatch } from "react-redux";
import { ReduxDispatch } from '../../types/redux/ReduxDispatch';

export function useReduxDispatch(): ReduxDispatch {
    return useDispatch<ReduxDispatch>();
}